export const SET_INDISTRESS_ENABLED = 'SET_INDISTRESS_ENABLED';
export const SET_INDISTRESS_DISABLED = 'SET_INDISTRESS_DISABLED';
export const SET_MEETING_NAME = 'SET_MEETING_NAME';
export const SET_RECORDING_ENABLED = 'SET_RECORDING_ENABLED';
export const SET_JIBRI_READY = 'SET_JIBRI_READY';
